import { useCallback } from 'react'
import { useWalletStore } from '@/stores/walletStore'
import { useModalStore } from '@/stores/modalStore'
import { walletService } from '@/lib/wallet/walletService'
import { toast } from '@/stores/toastStore'

export function useWallet() {
  const wallet = useWalletStore()
  const modal = useModalStore()

  // isAdmin: wallet address must match VITE_ADMIN_WALLET (case-insensitive)
  const adminWallet = (import.meta.env.VITE_ADMIN_WALLET as string | undefined)?.toLowerCase() ?? ''
  const isAdmin =
    !!wallet.address && !!adminWallet && wallet.address.toLowerCase() === adminWallet

  const connect = useCallback(async () => {
    modal.open('wallet')
  }, [modal])

  const disconnect = useCallback(async () => {
    try {
      await walletService.disconnect()
    } catch (err) {
      // Log for debugging but still clear local state
      console.warn('[useWallet] disconnect cleanup error (non-fatal):', err)
    }
    wallet.disconnect()
    toast.info('Wallet disconnected')
  }, [wallet])

  const switchChain = useCallback(async (chainId: number) => {
    try {
      await walletService.switchChain(chainId)
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Failed to switch chain'
      toast.error('Chain switch failed', msg)
    }
  }, [])

  const shortAddress = wallet.address
    ? `${wallet.address.slice(0, 6)}…${wallet.address.slice(-4)}`
    : null

  return {
    address: wallet.address,
    chainId: wallet.chainId,
    walletType: wallet.walletType,
    providerName: wallet.providerName,
    isConnected: wallet.isConnected,
    isConnecting: wallet.isConnecting,
    balance: wallet.balance,
    isAdmin,
    connect,
    disconnect,
    switchChain,
    shortAddress,
  }
}
